<script setup lang="ts">
import { defineProps } from 'vue'
const props = defineProps({
  aboutInfos:{}
})
</script>

<template>
  <div class="uk-padding uk-width-1-1">
    <div class="uk-container">

      <div class="" data-uk-grid>
        <div class="uk-width-3-5@xl uk-width-3-5@l uk-width-1-1@m">
          <!-- text content -->
          <h2 class="uk-margin-remove">{{props.aboutInfos?.title}}</h2>
          <p class="uk-text-muted impx-text-large uk-margin-remove">{{props.aboutInfos?.subttitle}}</p>
          <p class="impx-text-large">{{props.aboutInfos?.description[0]??''}}</p>
          <p class="uk-margin-bottom data-uk-dropcap" :key="index" v-for="(desc, index) in props.aboutInfos?.description??[]">
            {{props.aboutInfos?.description[index+1]}}
          </p>


<!--          <div class="" data-uk-grid>&lt;!&ndash; network &ndash;&gt;-->
<!--            <div class="uk-width-1-1">-->
<!--              <h4 class="uk-heading-line uk-heading-bullet"><span>Notre Réseaux de residences</span></h4>-->
<!--              <div class="uk-child-width-1-3@xl uk-child-width-1-3@l uk-child-width-1-3@m uk-child-width-1-1@s uk-grid-small" data-uk-grid>-->
<!--                <div>&lt;!&ndash; network location #1 &ndash;&gt;-->
<!--                  <div class="uk-card uk-card-default color1 uk-light">-->
<!--                    <div class="uk-card-body impx-padding-small">-->
<!--                      <h6>Spain</h6>-->
<!--                      <ul class="uk-list impx-list">-->
<!--                        <li><i class="fa fa-home"></i>Heaven Street 107</li>-->
<!--                        <li><i class="fa fa-phone"></i>1-800-123-4455</li>-->
<!--                        <li><i class="fa fa-envelope"></i>book@sativa-hotel.com</li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div>&lt;!&ndash; network location #2 &ndash;&gt;-->
<!--                  <div class="uk-card uk-card-default color2 uk-light">-->
<!--                    <div class="uk-card-body impx-padding-small">-->
<!--                      <h6>France</h6>-->
<!--                      <ul class="uk-list impx-list">-->
<!--                        <li><i class="fa fa-home"></i>Heaven Street 107</li>-->
<!--                        <li><i class="fa fa-phone"></i>1-800-123-4455</li>-->
<!--                        <li><i class="fa fa-envelope"></i>book@sativa-hotel.com</li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div>&lt;!&ndash; network location #3 &ndash;&gt;-->
<!--                  <div class="uk-card uk-card-default color3 uk-light">-->
<!--                    <div class="uk-card-body impx-padding-small">-->
<!--                      <h6>Brazil</h6>-->
<!--                      <ul class="uk-list impx-list">-->
<!--                        <li><i class="fa fa-home"></i>Heaven Street 107</li>-->
<!--                        <li><i class="fa fa-phone"></i>1-800-123-4455</li>-->
<!--                        <li><i class="fa fa-envelope"></i>book@sativa-hotel.com</li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <!-- network -->

        </div>

        <div class="uk-width-2-5@xl uk-width-2-5@l uk-width-1-1@m">
          <div class="uk-card uk-card-default uk-card-small uk-margin-bottom">
            <div class="uk-card-body"><!-- image content -->
              <img :src="props.aboutInfos?.image?.url"  alt="room-3">
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>

</style>